<template>
  <b-container fluid id="app">
    <b-row class="row-top">
      <b-col cols="12" class="row-top">
        <TopBar />
      </b-col>
    </b-row>
    <b-row class="row-content">
      <b-col cols="12">
        <Content />
      </b-col>
    </b-row>
    <b-row class="row-footer">
      <b-col cols="12">
        <Footer />
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
  import TopBar from './components/Header/TopBar'
  import Content from './components/Content/Content'
  import Footer from './components/Footer/Footer'

  export default {
    name: 'app',
    components: {
      TopBar,
      Content,
      Footer,
    }
  }
</script>

<style scoped lang="scss">
  @import "../scss/custom";

  #app {
    height: 100vh;
    min-height: 400px;
    display: flex;
    flex-direction: column;

    > div {
      flex: 0 0 auto;

      &.row-content {
        flex-grow: 1;
      }
    }
  }
</style>